import { createTestIds } from '@duke-hq/lib/createTestId';

export const testIds = createTestIds('apps-admin-web-UnitAssessment-components', [
  'slideRequirementChip',
  'linkedRequirementChip',
  'linkRequirementsButton',
  'requirementOption',
  'foundationSkillOption',
]);
